import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { count, rate } from './model'

// "By partner": what each partner sent, how much of it was blocked and why.
// The backend puts spiking partners first; their rows are highlighted and
// each gets its own line under the table, in the backend's words.
export default function PartnersCard({ rows = [] }) {
  const spikes = rows.filter((r) => r.spike)
  return (
    <section className="card" aria-labelledby="bk-partners-title" style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <h2 id="bk-partners-title" style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>By partner</h2>
      {rows.length === 0 ? (
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>No partner had a submission blocked in this range.</p>
      ) : (
        <div className="bk-table-scroll">
          <table className="bk-table">
            <thead>
              <tr>
                <th scope="col">Partner</th>
                <th scope="col" className="bk-num">Sent</th>
                <th scope="col" className="bk-num">Blocked</th>
                <th scope="col">Block rate</th>
                <th scope="col">Top reason</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id ?? `name:${r.name}`} className={r.spike ? 'bk-row-spike' : undefined} data-spike={r.spike ? 'true' : undefined}>
                  <td style={{ fontWeight: 600 }}>
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                      {r.spike && <AlertTriangle size={13} aria-label="Spike" style={{ color: 'var(--red)', flexShrink: 0 }} />}
                      {r.name}
                    </span>
                  </td>
                  <td className="bk-num">{count(r.sent)}</td>
                  <td className="bk-num">{count(r.blocked)}</td>
                  <td>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 110 }}>
                      <span style={{ fontVariantNumeric: 'tabular-nums', width: 44, textAlign: 'right', color: r.spike ? 'var(--red)' : 'var(--text-primary)', fontWeight: r.spike ? 700 : 400 }}>
                        {rate(r.block_rate)}
                      </span>
                      <span className="bk-track" aria-hidden="true" style={{ flex: 1, minWidth: 40 }}>
                        <span style={{ display: 'block', height: '100%', width: `${Math.min(100, Number(r.block_rate || 0) * 100)}%`, background: r.spike ? 'var(--red)' : 'var(--accent)', borderRadius: 99 }} />
                      </span>
                    </span>
                  </td>
                  <td style={{ color: 'var(--text-secondary)' }}>{r.top_reason?.label || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {spikes.map((r) => (
        <div
          key={`spike-${r.id ?? r.name}`}
          role="alert"
          style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, padding: '8px 12px', borderRadius: 8, color: 'var(--red)', background: 'var(--red-bg)' }}
        >
          <AlertTriangle size={14} aria-hidden="true" style={{ flexShrink: 0, marginTop: 2 }} />
          <span><strong style={{ fontWeight: 700 }}>{r.name}:</strong> {r.spike.text}</span>
        </div>
      ))}
    </section>
  )
}
